import { render, staticRenderFns } from "./Shield.vue?vue&type=template&id=a39cabc6&scoped=true&"
import script from "./Shield.vue?vue&type=script&lang=js&"
export * from "./Shield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39cabc6",
  null
  
)

export default component.exports